import { render, staticRenderFns } from "./EditorEmbedVideoButton.vue?vue&type=template&id=21419f8e"
import script from "./EditorEmbedVideoButton.vue?vue&type=script&lang=js"
export * from "./EditorEmbedVideoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports